import { createAPIInstance, createHttpMethods } from '@repo/services/api';

import { auth } from './firebase';

const affiliateBaseURL = import.meta.env.VITE_APP_IS_MOCKING
  ? 'http://localhost:3002'
  : import.meta.env.VITE_APP_API_BASE_URL;

const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN;

const axiosInstance = createAPIInstance(
  {
    useLoading: false,
    useToken: true,
    // useToken: false,
    baseURL: affiliateBaseURL,
    useErrorToast: true,
    useRedirectAndLogout: false,
  },
  auth,
  cookieDomain
);

const http = createHttpMethods(axiosInstance);

export default http;
export { axiosInstance };
